// Shared visual primitives ported from the Claude Design "Album Admin" project.
import type { CSSProperties, ReactNode } from "react";

// ── icon set (admin chrome + a few from the guest kit) ──
const ICONS: Record<string, ReactNode> = {
  dash: (<><rect x="3" y="3" width="7" height="9" rx="1.3" /><rect x="14" y="3" width="7" height="5" rx="1.3" /><rect x="14" y="12" width="7" height="9" rx="1.3" /><rect x="3" y="16" width="7" height="5" rx="1.3" /></>),
  shield: (<><path d="M12 3 5 6v5c0 4.2 2.9 7.6 7 9 4.1-1.4 7-4.8 7-9V6Z" /><path d="m9 12 2 2 4-4" /></>),
  layers: (<><path d="m12 3 9 5-9 5-9-5Z" /><path d="m3 13 9 5 9-5" /></>),
  users: (<><circle cx="9" cy="8" r="3.2" /><path d="M3.5 19c0-3 2.5-5 5.5-5s5.5 2 5.5 5" /><path d="M16 5.2a3.2 3.2 0 0 1 0 6" /><path d="M17.5 14c2.2.4 3.9 2.2 3.9 4.6" /></>),
  gear: (<><circle cx="12" cy="12" r="3" /><path d="M12 2.5v2.4M12 19.1v2.4M21.5 12h-2.4M4.9 12H2.5M18.7 5.3l-1.7 1.7M7 17l-1.7 1.7M18.7 18.7 17 17M7 7 5.3 5.3" /></>),
  eye: (<><path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12Z" /><circle cx="12" cy="12" r="3" /></>),
  eyeoff: (<><path d="M4 4l16 16" /><path d="M9.5 9.6a3 3 0 0 0 4.2 4.2" /><path d="M6.5 6.7C3.9 8.3 2.5 12 2.5 12s3.5 6.5 9.5 6.5c1.5 0 2.8-.3 4-.9" /><path d="M17 16.3c2.4-1.6 4.5-4.3 4.5-4.3S18 5.5 12 5.5c-.6 0-1.2.1-1.7.2" /></>),
  flag: (<><path d="M5 21V4" /><path d="M5 4.5h11l-2 3.5 2 3.5H5" /></>),
  trash: (<><path d="M4 7h16" /><path d="M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" /><path d="M6 7l1 12.5a1.5 1.5 0 0 0 1.5 1.4h7a1.5 1.5 0 0 0 1.5-1.4L18 7" /></>),
  dots: (<><circle cx="5" cy="12" r="1.6" /><circle cx="12" cy="12" r="1.6" /><circle cx="19" cy="12" r="1.6" /></>),
  cal: (<><rect x="3.5" y="5" width="17" height="16" rx="2" /><path d="M3.5 9.5h17M8 3v4M16 3v4" /></>),
  link: (<><path d="M9.5 14.5 14.5 9.5" /><path d="M11 7l1.2-1.2a3.5 3.5 0 0 1 5 5L16 12" /><path d="M13 17l-1.2 1.2a3.5 3.5 0 0 1-5-5L8 12" /></>),
  bell: (<><path d="M6 9a6 6 0 0 1 12 0c0 5 2 6 2 6H4s2-1 2-6Z" /><path d="M10 19a2 2 0 0 0 4 0" /></>),
  arrowup: (<><path d="M12 19V6" /><path d="m6 11 6-6 6 6" /></>),
  arrowdown: (<><path d="M12 5v13" /><path d="m6 13 6 6 6-6" /></>),
  clock: (<><circle cx="12" cy="12" r="8.3" /><path d="M12 7.5V12l3 2" /></>),
  pencil: (<><path d="m4 20 1-4L16 5l3 3L8 19Z" /><path d="m14 7 3 3" /></>),
  star: <path d="m12 4 2.3 5.2 5.7.5-4.3 3.8 1.3 5.5L12 16.6 6.7 19l1.3-5.5L3.7 9.7l5.7-.5Z" />,
  download2: (<><path d="M12 4v10" /><path d="m8 11 4 4 4-4" /><path d="M5 18.5h14" /></>),
  qr: (<><rect x="3.5" y="3.5" width="6.5" height="6.5" rx="1" /><rect x="14" y="3.5" width="6.5" height="6.5" rx="1" /><rect x="3.5" y="14" width="6.5" height="6.5" rx="1" /><path d="M14 14h3v3M20.5 14v3M14 19v1.5h3M19 19.5h1.5v1" /></>),
  logout: (<><path d="M14 4h4a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-4" /><path d="M10 12h9" /><path d="m13 8-4 4 4 4" /></>),
  grid: (<><rect x="4" y="4" width="7" height="7" rx="1.2" /><rect x="13" y="4" width="7" height="7" rx="1.2" /><rect x="4" y="13" width="7" height="7" rx="1.2" /><rect x="13" y="13" width="7" height="7" rx="1.2" /></>),
  face: (<><circle cx="12" cy="12" r="8.4" /><circle cx="9.3" cy="10.6" r="0.9" fill="currentColor" stroke="none" /><circle cx="14.7" cy="10.6" r="0.9" fill="currentColor" stroke="none" /><path d="M9 14.6c.9.9 1.9 1.3 3 1.3s2.1-.4 3-1.3" /></>),
  upload: (<><path d="M12 15.5V5" /><path d="m7.5 9 4.5-4.5L16.5 9" /><path d="M5 15v2.5a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V15" /></>),
  sparkle: (<><path d="M12 4c.4 3.2 1.4 4.2 4.6 4.6-3.2.4-4.2 1.4-4.6 4.6-.4-3.2-1.4-4.2-4.6-4.6C10.6 8.2 11.6 7.2 12 4Z" /><path d="M18 14c.2 1.6.7 2.1 2.3 2.3-1.6.2-2.1.7-2.3 2.3-.2-1.6-.7-2.1-2.3-2.3 1.6-.2 2.1-.7 2.3-2.3Z" /></>),
  share: (<><circle cx="6" cy="12" r="2.4" /><circle cx="17" cy="6" r="2.4" /><circle cx="17" cy="18" r="2.4" /><path d="m8.1 10.9 6.8-3.8M8.1 13.1l6.8 3.8" /></>),
  plus: (<><path d="M12 5v14" /><path d="M5 12h14" /></>),
  check: <path d="m5 12.5 4.5 4.5L19 7" />,
  search: (<><circle cx="11" cy="11" r="6" /><path d="m20 20-4.3-4.3" /></>),
  home: (<><path d="M4 11 12 4l8 7" /><path d="M6 9.5V19a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V9.5" /></>),
  close: (<><path d="M6 6 18 18" /><path d="M18 6 6 18" /></>),
  chevron: <path d="m9 6 6 6-6 6" />,
  menu: (<><path d="M4 7h16" /><path d="M4 12h16" /><path d="M4 17h16" /></>),
  arrowleft: (<><path d="M19 12H5" /><path d="m11 6-6 6 6 6" /></>),
  refresh: (<><path d="M20 11a8 8 0 1 0-1.9 5.2" /><path d="M20 5v6h-6" /></>),
};

export function Icon({ name, size = 20, stroke = 1.6, fill = "none", className = "", style = {} }: {
  name: string; size?: number; stroke?: number; fill?: string; className?: string; style?: CSSProperties;
}) {
  return (
    <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill={fill}
      stroke="currentColor" strokeWidth={stroke} strokeLinecap="round" strokeLinejoin="round" style={style} aria-hidden="true">
      {ICONS[name] ?? null}
    </svg>
  );
}

export function Engraved({ children, size = 13, className = "", style = {} }: { children: ReactNode; size?: number; className?: string; style?: CSSProperties }) {
  return <div className={"engraved " + className} style={{ fontSize: size, ...style }}>{children}</div>;
}
export function Script({ children, size = 44, className = "", style = {} }: { children: ReactNode; size?: number; className?: string; style?: CSSProperties }) {
  return <div className={"script " + className} style={{ fontSize: size, ...style }}>{children}</div>;
}

export function SectionHead({ kicker, title, sub, actions }: { kicker: string; title: string; sub?: string; actions?: ReactNode }) {
  return (
    <div className="sec-head">
      <div>
        <Engraved size={11} style={{ color: "var(--c-ink-soft)", letterSpacing: "0.28em" }}>{kicker}</Engraved>
        <Script size={42} style={{ color: "var(--c-accent)", marginTop: 2 }}>{title}</Script>
        {sub && <p className="sec-sub">{sub}</p>}
      </div>
      {actions && <div className="sec-actions">{actions}</div>}
    </div>
  );
}

export function Toggle({ on, onChange, disabled }: { on: boolean; onChange: (v: boolean) => void; disabled?: boolean }) {
  return (
    <button className={"toggle" + (on ? " on" : "")} disabled={disabled} onClick={() => onChange(!on)} role="switch" aria-checked={on}>
      <span className="toggle-dot" />
    </button>
  );
}

// deterministic soft gradient wash for placeholder thumbs / avatars
const WASHES: [string, string, string, string][] = [
  ["155deg", "#f6d7e4", "#e7b7cd", "#cdd9e3"], ["165deg", "#dfe7ec", "#cdd9e3", "#e9c4d4"],
  ["135deg", "#f1e2d4", "#e7c9b3", "#d9b9c8"], ["145deg", "#e7d4e0", "#c79bc0", "#dcc0a6"],
  ["170deg", "#f4d8c0", "#e6a982", "#e9c4d4"], ["150deg", "#dde6e4", "#b6cabf", "#e7d3c2"],
  ["140deg", "#f3c9da", "#dd6fa6", "#f0e0cb"], ["160deg", "#ece2d0", "#d8c39a", "#cdd9e3"],
];
export function washFor(seed: number): CSSProperties {
  const w = WASHES[Math.abs(seed) % WASHES.length]!;
  return {
    backgroundImage:
      `radial-gradient(120% 90% at 25% 20%, rgba(255,255,255,0.55), rgba(255,255,255,0) 55%),` +
      `radial-gradient(100% 80% at 80% 90%, ${w[3]}, rgba(255,255,255,0) 60%),` +
      `linear-gradient(${w[0]}, ${w[1]}, ${w[2]})`,
  };
}

export function Avatar({ name, seed = 0, size = 34 }: { name: string; seed?: number; size?: number }) {
  const initials = name.split(" ").map((w) => w[0]).slice(0, 2).join("").toUpperCase();
  return (
    <span className="avatar" style={{ width: size, height: size, ...washFor(seed) }}>
      <span className="avatar-init" style={{ fontSize: size * 0.36 }}>{initials}</span>
    </span>
  );
}

// small engraved flourish used in footers
export function Ornament({ color = "currentColor", width = 120 }: { color?: string; width?: number }) {
  return (
    <svg viewBox="0 0 120 16" width={width} height={width * (16 / 120)} fill="none" stroke={color} strokeWidth="1" strokeLinecap="round">
      <path d="M10 8h36" /><path d="M110 8H74" />
      <path d="M46 8c4-5 8-5 14 0 6 5 10 5 14 0" />
      <circle cx="60" cy="8" r="2" fill={color} stroke="none" />
      <path d="M6 8c1.5-2 1.5-2 0-4M114 8c-1.5-2-1.5-2 0-4M6 8c1.5 2 1.5 2 0 4M114 8c-1.5 2-1.5 2 0 4" />
    </svg>
  );
}

// lightweight decorative sprig (stand-in for the guest app's full florals)
export function FloralSpray({ width = 180, height = 130, color = "var(--c-accent)" }: { width?: number; height?: number; color?: string }) {
  return (
    <svg viewBox="0 0 180 130" width={width} height={height} fill="none" stroke={color} strokeWidth="1.4" strokeLinecap="round" opacity="0.55" aria-hidden="true">
      <path d="M90 120 C90 90 78 70 70 55 M90 120 C90 88 104 68 112 54" />
      <g fill={color} stroke="none" opacity="0.85">
        <circle cx="70" cy="52" r="6" /><circle cx="112" cy="51" r="6" /><circle cx="90" cy="42" r="7" />
        <circle cx="80" cy="62" r="4" /><circle cx="102" cy="62" r="4" />
      </g>
      <path d="M62 70c-8-2-14-8-16-16M118 70c8-2 14-8 16-16M78 84c-6 2-12 1-17-3M102 84c6 2 12 1 17-3" />
    </svg>
  );
}
